export type Product = {
  id: string;
  revision: string;
  name: string;
  unit: "litre" | "piece";
  quantity: string;
  threshold: string | null;
  low_stock: boolean;
  balance_revision: string;
};
export type Adjustment = {
  id: string;
  kind: "receipt" | "correction" | "decrement" | "threshold";
  reason: string;
  quantity_before: string;
  quantity_after: string;
  quantity_change: string;
  threshold_before: string | null;
  threshold_after: string | null;
  actor: string;
  created_at: string;
};
export function quantity(value: string, locale: string) {
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 3 }).format(
    Number(value),
  );
}
